import { useCallback } from 'react';
import clsx from 'clsx';
import NiceModal from '@ebay/nice-modal-react';

import UiLocationIcon from '@/icons/UiLocationIcon';
import UiCloseIcon from '@/icons/UiCloseIcon';
import UiOkIcon from '@/icons/UiOkIcon';

import { modals } from '@/modals';
import Button from '@/components/Button';
import useLocationPermission from '@/app/hooks/useLocationPermission';

import './LobbyPage.css';
import { EVENTS, gtag } from '@/lib/gtag';

/**
 * The location row of the lobby checklist, mirroring the camera/microphone
 * lines. Location can be blocked on the site level or by the OS Location
 * Services, so a failed request opens the location reset modal with both
 * unblock paths.
 */
export default function LocationPermissionLine() {
  const { state, request } = useLocationPermission(true);

  const onRequestPermission = useCallback(() => {
    request().catch(() => {
      gtag(EVENTS.SHOW_MODAL, { location: true });
      NiceModal.show(modals.RESET_LOCATION_MODAL);
    });
  }, [request]);

  if (state === 'unsupported') {
    return null;
  }
  const granted = state === 'granted';

  return (
    <div className="self-stretch rounded-xl bg-whitesmoke flex flex-row items-center justify-between p-3 gap-[20px]">
      <div className="flex flex-row items-center justify-start gap-[5px]">
        <div className="w-8 flex flex-row items-center justify-center py-0 px-0.5 box-border relative">
          <UiLocationIcon
            className={clsx(
              "h-6 w-6 relative",
              { "svg-fill-black": granted }
            )}
          />
          {!granted && (
            <div className="border-solid border-white flex flex-row items-center justify-center rounded-icon-circle bg-orange-base bore h-[12px] w-[12px] !m-[0] absolute top-[11px] left-[17px] z-[1] border">
              <UiCloseIcon />
            </div>
          )}
        </div>
        <div className="relative leading-[20px] inline-block min-w-[119px]">
          Location is {granted ? "enabled" : "disabled"}
        </div>
      </div>
      {!granted && (
        <Button
          onClick={onRequestPermission}
          className="text-xs font-button-big"
          variant="primary"
          size="xs"
        >
          Enable
        </Button>
      )}
      {granted && (
        <UiOkIcon />
      )}
    </div >
  );
}
